import { LegalPage, Section, SubSection } from "./LegalPage";

export function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="March 20, 2026">
      <Section title="1. Information We Collect">
        <SubSection title="Account Information">
          <ul>
            <li>Email address (for authentication and communication)</li>
            <li>Display name</li>
            <li>Profile picture (optional)</li>
            <li>iRacing customer ID</li>
            <li>Google account identifier (if using Google sign-in)</li>
          </ul>
        </SubSection>
        <SubSection title="Telemetry Data">
          <ul>
            <li>iRacing .ibt telemetry files you upload</li>
            <li>Derived analysis data (lap times, corner performance, tire data, setup configurations)</li>
            <li>Session metadata (track, car, date, weather conditions)</li>
          </ul>
        </SubSection>
        <SubSection title="Usage Data">
          <ul>
            <li>Pages visited and features used</li>
            <li>Coaching report generation history</li>
            <li>Desktop agent connection status</li>
            <li>Browser type, operating system, and device information</li>
          </ul>
        </SubSection>
        <SubSection title="Payment Information">
          <p>Payment processing is handled by Stripe. SimSense does not store credit card numbers.</p>
        </SubSection>
      </Section>

      <Section title="2. How We Use Your Information">
        <ul>
          <li><strong>Provide the Service:</strong> Process telemetry, generate coaching reports, display dashboards</li>
          <li><strong>Improve the Service:</strong> Analyze usage patterns to improve features and performance</li>
          <li><strong>Communication:</strong> Send account-related emails (password resets, subscription changes)</li>
          <li><strong>Support:</strong> Respond to support tickets and resolve issues</li>
          <li><strong>Community Features:</strong> Display your profile, leaderboard entries, and shared content to other authenticated users (per your privacy settings)</li>
        </ul>
      </Section>

      <Section title="3. Data Sharing">
        <p>We do NOT sell your personal information. We share data only in these circumstances:</p>
        <ul>
          <li><strong>With your consent:</strong> When you enable public sharing of sessions or setups</li>
          <li><strong>Service providers:</strong> Stripe (payments), Backblaze B2 (file storage), OpenAI (coaching report generation — telemetry data only, no personal information)</li>
          <li><strong>Legal requirements:</strong> If required by law, court order, or government request</li>
          <li><strong>Safety:</strong> To prevent fraud, abuse, or harm to other users</li>
        </ul>
      </Section>

      <Section title="4. Data Retention">
        <ul>
          <li><strong>Free accounts:</strong> Telemetry data retained for 6 months from upload date</li>
          <li><strong>Pro accounts:</strong> Extended retention period</li>
          <li><strong>Account deletion:</strong> All personal data and telemetry deleted within 30 days of account deletion request</li>
          <li><strong>Coaching reports:</strong> Retained as long as the account is active</li>
        </ul>
      </Section>

      <Section title="5. Data Security">
        <ul>
          <li>All data transmitted via HTTPS/TLS encryption</li>
          <li>Authentication cookies are httpOnly and secure</li>
          <li>Telemetry files stored in encrypted cloud storage (Backblaze B2)</li>
          <li>Database access restricted to application services only</li>
        </ul>
      </Section>

      <Section title="6. Your Rights">
        <p>You have the right to:</p>
        <ul>
          <li><strong>Access:</strong> Request a copy of your personal data</li>
          <li><strong>Correction:</strong> Update inaccurate account information</li>
          <li><strong>Deletion:</strong> Request deletion of your account and data</li>
          <li><strong>Opt-out:</strong> Disable public sharing features and community visibility</li>
        </ul>
        <p>To exercise these rights, contact support@outlierspeedco.com or use the Settings page.</p>
      </Section>

      <Section title="7. Cookies">
        <p>SimSense uses the following cookies:</p>
        <ul>
          <li><strong>ss_access</strong> — Authentication session token (15 minutes, httpOnly)</li>
          <li><strong>ss_refresh</strong> — Session refresh token (7 days, httpOnly)</li>
          <li><strong>ss_auth_hint</strong> — Local auth state hint (localStorage)</li>
        </ul>
        <p>No third-party tracking cookies or advertising cookies are used.</p>
      </Section>

      <Section title="8. Children's Privacy">
        <p>SimSense is not intended for children under 13. We do not knowingly collect information from children under 13. If you believe a child has provided us with personal information, contact us to have it removed.</p>
      </Section>

      <Section title="9. Changes to This Policy">
        <p>We may update this Privacy Policy periodically. Material changes will be communicated via email or in-app notification. Continued use after changes constitutes acceptance.</p>
      </Section>

      <Section title="10. Contact">
        <p>For privacy-related questions: <strong>support@outlierspeedco.com</strong></p>
      </Section>
    </LegalPage>
  );
}
